import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Avatar as MuiAvatar,
  Box as MuiBox,
  Breadcrumbs as MuiBreadcrumbs,
  Chip as MuiChip,
  ClickAwayListener as MuiClickAwayListener,
  Container as MuiContainer,
  Divider as MuiDivider,
  FormControlLabel as MuiFormControlLabel,
  Grid as MuiGrid,
  IconButton as MuiIconButton,
  Menu as MuiMenu,
  Paper as MuiPaper,
  Radio as MuiRadio,
  Tab as MuiTab,
  Tabs as MuiTabs,
  TextField as MuiTextFieldBase,
} from "@material-ui/core"
import AlertBase from "@material-ui/lab/Alert"
import TabPanelBase from "@material-ui/lab/TabPanel"
import { borders, display, flexbox, palette, positions, shadows, sizing, spacing } from "@material-ui/system"
import { KeyboardDatePicker as FormikKeyboardDatePicker } from "formik-material-ui-pickers"
import styled from "styled-components/macro"

import CustomButton from "./Button"
import CustomCheckbox from "./Checkbox"
import CustomDatePicker from "./DatePicker"
import CustomErrorMessage from "./ErrorMessage"
import CustomLink from "./Link"
import CustomRadioGroup from "./RadioGroup"
import CustomSelect from "./Select"
import CustomSwitchInput from "./SwitchInput"
import CustomTextField from "./TextField"
import CustomTypography from "./Typography"

const makeBoxProps = (Component: any) =>
  styled(Component)(borders, display, flexbox, palette, positions, shadows, sizing, spacing)

CustomTextField.Email = makeBoxProps(CustomTextField.Email)
CustomTextField.PhoneNumber = makeBoxProps(CustomTextField.PhoneNumber)
CustomTextField.TaxId = makeBoxProps(CustomTextField.TaxId)

const CustomMuiTextField = makeBoxProps(MuiTextFieldBase)

export const Email = CustomTextField.Email
export const PhoneNumber = CustomTextField.PhoneNumber
export const TaxId = CustomTextField.TaxId

const componentMap: Record<string, any> = {
  Avatar: MuiAvatar,
  Paper: MuiPaper,
  Menu: MuiMenu,
  Breadcrumbs: MuiBreadcrumbs,
  Divider: MuiDivider,
  IconButton: MuiIconButton,
  Radio: MuiRadio,
  FormControlLabel: MuiFormControlLabel,
  Grid: MuiGrid,
  Chip: MuiChip,
  Container: MuiContainer,
  Alert: AlertBase,
  Button: CustomButton,
  Link: CustomLink,
  Checkbox: CustomCheckbox,
  ErrorMessage: CustomErrorMessage,
  Select: CustomSelect,
  Typography: CustomTypography,
  RadioGroup: CustomRadioGroup,
  TextField: CustomTextField,
  SwitchInput: CustomSwitchInput,
  MuiTextField: CustomMuiTextField,
  DatePicker: CustomDatePicker,
}

const MuiComponents = Object.entries(componentMap).reduce((acc, [key, Component]) => {
  acc[key] = makeBoxProps(Component)
  return acc
}, {} as Record<string, any>)

export const {
  Avatar,
  Paper,
  TextField,
  Typography,
  Alert,
  Button,
  Link,
  Checkbox,
  Menu,
  Breadcrumbs,
  Divider,
  ErrorMessage,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
  Select,
  Grid,
  Chip,
  SwitchInput,
  MuiTextField,
  Container,
} = MuiComponents

export const KeyboardDatePicker = FormikKeyboardDatePicker

export const Box = MuiBox
export const Tabs = MuiTabs
export const Tab = MuiTab
export const TabPanel = TabPanelBase
export const Accordion = MuiAccordion
export const AccordionSummary = MuiAccordionSummary
export const AccordionDetails = MuiAccordionDetails

export const ClickAwayListener = MuiClickAwayListener

export { Helmet } from "react-helmet-async"
export { AnimatedSwitch } from "react-router-transition"

export { default as BrowseButton } from "./BrowseButton"
export { default as Hidden } from "./Hidden"

export { default as Field } from "./Field"
export { default as FieldArray } from "./FieldArray"
export { default as Form } from "./Form"

export { default as BrowserRouter } from "./BrowserRouter"
export { default as Redirect } from "./Redirect"
export { default as Route } from "./Route"
export { default as Switch } from "./Switch"

export { default as ExcelGenerator } from "./ExcelGenerator"
export { default as ImageLightbox } from "./ImageLightbox"
export { default as Modal } from "./Modal"
export { default as Notification } from "./Notification"

export { default as FontAwesomeIcon } from "./FontAwesomeIcon"
export { default as PopMenu } from "./PopMenu"
export { default as UploadAvatar } from "./UploadAvatar"

export { default as Editor } from "./Editor"
export { default as Table } from "./Table"

export { default as DatePicker } from "./DatePicker"
export { default as ProgressBar } from "./ProgressBar"

export { Carousel } from "./Carousel"
